import React from "react"
import SvgSujetApa from "@Components/CustomIcon/SvgSujetApa"
import SvgSujetDietetique from "@Components/CustomIcon/SvgSujetDietetique"
import SvgSujetMedicaux from "@Components/CustomIcon/SvgSujetMedicaux"
import SvgSujetPsychologie from "@Components/CustomIcon/SvgSujetPsychologie"

const topics = [
    {
        id: 1,
        content: <SvgSujetApa width={"100%"} />
    },
    {
        id: 2,
        content: <SvgSujetDietetique width={"100%"} />
    },
    {
        id: 3,
        content: <SvgSujetPsychologie width={"100%"} />
    },
    {
        id: 4,
        content: <SvgSujetMedicaux width={"100%"} />
    }
]

const forumData = (axisData) => {
    let res = []

    if (axisData?.length > 0) {
        res = Array.from(axisData, (item) => {
            return {
                id: item?.id,
                title: item?.subject,
                subContent: {
                    title: item?.content,
                    messages: item?.answers?.length || 0
                }
            }
        })
    }

    return res
}

const topicMessages = [
    {
        id: 1,
        post: "Tu as déjà pratiqué du sport ? De façon régulière ? Ton but est de simplement te maintenir en bonne santé ? Moi je te conseillerais de faire des petites exercices pendant 15 minutes pour d’augmenter. Tu peux aussi essayer de marcher tous les jours !",
        user: {
            fullName: "User 1",
            postedAt: "le 19/11/20 à 13h12"
        }
    }
]

export { topics, topicMessages, forumData }
